import React from 'react';
import classnames from 'classnames';

export default function Helptext({ className, children }) {
  return (
    <p className={classnames('text-sm text-gray-500', className)}>{children}</p>
  );
}
